import React from 'react';

import { Button as AntdButton } from 'antd';

import { useBaseFormContext } from 'components/BaseForm/BaseFormContext';

import {
  HistoriqueAction,
  RecuperationActionsUtilisateurFormInProgressStatus,
  RecuperationActiviteUtilisateurFormValues,
} from '../../types';

import './FormFooter.less';

interface FormFooterProps {
  handleClick: (historiqueAction: HistoriqueAction) => void;
  onCancel: () => void;
  hasError?: boolean;
  inProgressActionStatus?: RecuperationActionsUtilisateurFormInProgressStatus;
}

function FormFooter({
  handleClick,
  onCancel,
  hasError,
  inProgressActionStatus,
}: FormFooterProps) {
  const context =
    useBaseFormContext<RecuperationActiviteUtilisateurFormValues>();

  function resetForm() {
    onCancel();
    context.setFieldsValue({
      id: undefined,
      nom: undefined,
      prenom: undefined,
      dateDebut: undefined,
      dateFin: undefined,
    });
  }

  function handleSubmit(actionType: HistoriqueAction) {
    handleClick(actionType);
    context.submit();
  }

  return (
    <div className="RenderButtonActions">
      <AntdButton className="RenderButtonAction" onClick={resetForm}>
        Réinitialiser
      </AntdButton>
      <AntdButton
        className="RenderButtonAction"
        type="primary"
        onClick={() => handleSubmit('actions')}
        disabled={inProgressActionStatus?.actions.inProgress || hasError}
        loading={inProgressActionStatus?.actions.inProgress}
      >
        Historique des actions
      </AntdButton>
      <AntdButton
        className="RenderButtonAction"
        type="primary"
        onClick={() => handleSubmit('connexions')}
        disabled={inProgressActionStatus?.connexions.inProgress || hasError}
        loading={inProgressActionStatus?.connexions.inProgress}
      >
        Historique des connexions
      </AntdButton>
      <AntdButton
        className="RenderButtonAction"
        type="primary"
        onClick={() => handleSubmit('consultations')}
        disabled={inProgressActionStatus?.consultations.inProgress || hasError}
        loading={inProgressActionStatus?.consultations.inProgress}
      >
        Historique des consultations
      </AntdButton>
    </div>
  );
}

export default FormFooter;
